import dayjs from 'dayjs';

//
const formatDate = (isoDateString, isDateTime = true) => {
    if (!isoDateString)
        return null;
    const dateObject = new Date(isoDateString);
    const options = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        timeZone: "UTC"
    };
    const twoDigitDay = padSingleDigitWithZero(dateObject.getUTCDate());
    const twoDigitMonth = padSingleDigitWithZero(dateObject.getUTCMonth() + 1);
    const fourDigitYear = dateObject.getUTCFullYear();
    return !isDateTime ? `${twoDigitMonth}/${twoDigitDay}/${fourDigitYear}` : dateObject.toLocaleString(undefined, options).replace(',', '');
};
const formatCustomTypeDate = (isoDateString, isDateTime = true) => {
    const dateObject = new Date(isoDateString);
    const twoDigitDay = padSingleDigitWithZero(dateObject.getDate()).toLocaleString();
    const twoDigitMonth = padSingleDigitWithZero(dateObject.getMonth() + 1).toLocaleString();
    const fourDigitYear = dateObject.getFullYear();
    return isDateTime ? `${fourDigitYear}-${twoDigitMonth}-${twoDigitDay}T00:00:00` : `${fourDigitYear}-${twoDigitMonth}-${twoDigitDay}`;
};
const padSingleDigitWithZero = (number) => {
    return number < 10 ? `0${number}` : `${number}`;
};
const getFormattedDateTime = (dateTimeStr) => {
    if (!dateTimeStr)
        return null;
    return dayjs(dateTimeStr).format("MM/DD/YYYY HH:mm");
};
const formatDestructionDate = (isoDateString) => {
    const dateObject = new Date(isoDateString);
    const twoDigitDay = padSingleDigitWithZero(dateObject.getDate()).toLocaleString();
    const monthString = dateObject.toLocaleString('default', { month: 'short' }).toLocaleString();
    const fourDigitYear = dateObject.getFullYear();
    return `${twoDigitDay} ${monthString} ${fourDigitYear}`;
};

export { formatCustomTypeDate, formatDate, formatDestructionDate, getFormattedDateTime, padSingleDigitWithZero };
